import React from "react";

const VaccinesTable = ({ content }) => {
  return (
    <div id="vaccinesTable">
      <div className="first-column">
        {content.rows.map((row, i) => (
          <div
            key={i}
            className={`row${i === 0 ? " first-row" : ""}${i === 9 ? " total-row" : ""}${
              i === 10 ? " blank-row" : ""
            }`}>
            {row.cells.map(
              (cell, callIndex) =>
                callIndex === 0 && (
                  <div
                    key={callIndex}
                    className={`cell ${cell.isHeader === true ? "header" : "content"}`}
                    style={{ backgroundColor: `${cell.color}` }}
                    dangerouslySetInnerHTML={{ __html: cell.content }}
                  />
                )
            )}
          </div>
        ))}
      </div>
      <div className="other-columns">
        {content.rows.map((row, i) => (
          <div
            key={i}
            className={`row${i === 0 ? " first-row" : ""}${i === 9 ? " total-row" : ""}${
              i === 10 ? " blank-row" : ""
            }`}>
            {row.cells.map(
              (cell, callIndex) =>
                callIndex !== 0 && (
                  <div
                    key={callIndex}
                    className={`cell ${cell.isHeader === true ? "header" : "content"} ${
                      cell.isCentered ? "centered bigger" : ""
                    }`}
                    style={{ backgroundColor: `${cell.color}` }}
                    dangerouslySetInnerHTML={{
                      __html: `${cell.content || ""}<span class="subtitle">${cell.subtitle || ""}</span>`
                    }}
                  />
                )
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default VaccinesTable;
